/*
 * Project: xpenser-client
 * FilePath: /src/app/components/navigation/index.tsx
 * File: index.tsx
 * Created Date: Saturday, September 19th 2020, 2:20:38 am
 * Author: Craig Bojko (craig@pixelventures.co.uk)
 * -----
 * Last Modified: Sat Sep 19 2020
 * Modified By: Craig Bojko
 * -----
 * Copyright (c) 2020 Pixel Ventures Ltd.
 * ------------------------------------
 * <<licensetext>>
 */

import React from 'react'
import { Link } from 'react-router-dom'
import {
  makeStyles,
  Theme,
  Drawer,
  Icon,
  ListItem,
  List,
  ListItemIcon,
  ListItemText,
  Divider
} from '@material-ui/core'

import { INavigation } from '@common/interfaces/iNavigation'
import navigationOptions, { INavigationOption as NavigationOption } from '../../../config/app/navigationOptions'

const drawerWidth = 300

const useStyles = makeStyles((theme: Theme) => ({
  toolbar: theme.mixins.toolbar,
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',

    '& ul': {
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
      justifyContent: 'space-between'
    }
  },
  drawerPaper: {
    width: drawerWidth,
  },
  drawerOpen: {
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    })
  },
  drawerClose: {
    overflowX: 'hidden',
    width: theme.spacing(7) + 1,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),

    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9) + 1,
    },
  }
}))

export const Navigation: React.FC<INavigation> = ({ open }) => {
  const classes = useStyles()

  return (
    <Drawer
      variant='permanent'
      anchor='left'
      open={open}
      className={`${classes.drawer} ${open ? classes.drawerOpen : classes.drawerClose }`}
      classes={{
        paper: `${classes.drawerPaper} ${open ? classes.drawerOpen : classes.drawerClose }`
      }}
    >
      <div className={classes.toolbar} />
      <List>
        <div>
          {navigationOptions.map(({ label, icon, link }: NavigationOption) => (
            <ListItem button key={label} component={Link} to={link}>
              <ListItemIcon>
                <Icon>{icon}</Icon>
              </ListItemIcon>
              <ListItemText primary={label} />
            </ListItem>
          ))}
        </div>
        <Divider />
        <div>
          <ListItem button key={'logout'} component={Link} to='/logout'>
            <ListItemIcon>
              <Icon>logout</Icon>
            </ListItemIcon>
            <ListItemText primary={'Logout'} />
          </ListItem>
        </div>
      </List>
    </Drawer>
  )
}

export default Navigation
